import { useSyncExternalStore } from "react";
import type { ActionId } from "./actions.ts";
import { pageKeys, type KeyTable } from "./page.ts";

/**
 * The label of an action's key for a React surface that names it (P1.9-T50; ADR-061's amendment "key rebinding",
 * decision 11): the surface draws again when Settings' Apply changes the table.
 *
 * @param action The action.
 * @param keys The table; the page's unless given.
 * @returns The label of the key the action is bound to now.
 * @example
 * const label = useKeyLabel("inventory");
 * // "I"
 */
export function useKeyLabel(action: ActionId, keys: KeyTable = pageKeys): string {
  /**
   * Reads the label now.
   *
   * @returns The label.
   */
  const read = (): string => keys.label(action);
  return useSyncExternalStore(keys.subscribe, read, read);
}
